import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AuthContentWrapper from "./components/AuthContentWrapper";
import { Column, SizedBox } from "../../common/components/CommonBaseComponents";
import { C2Text, T1Text } from "../../common/components/text/CustomText";
import Translate from "../../common/translate/Translate";
import CustomInput from "../../common/components/input/CustomInput";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import Role from "../../common/enums/Role";
import LocalStorageKey from "../../common/enums/LocalStorageKey";
import { Theme } from "../../common/Theme";

const countryValues = [
    { label: "LG Admin", value: Role.Admin },
    { label: "Franchise Manager", value: Role.FranchiseManager },
    { label: "Call Center", value: Role.CallCenter },
    { label: "Store Manager", value: Role.StoreManager },
];

function DebugRoleChangePage() {
    const navigate = useNavigate();
    const [selectedRole, setSelectedRole] = useState(localStorage.getItem(LocalStorageKey.role) || Role.Admin);

    function handleChangeServerCountry(v) {
        setSelectedRole(v);
    }

    function handleSelect() {
        localStorage.setItem(LocalStorageKey.role, selectedRole);
        navigate(-1);
    }

    return (
        <AuthContentWrapper contentPadding={"62px 64px"} overflowY={"visible"}>
            <Column justifyContent={"center"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                    {Translate("common.laundryCrew")} {Translate("role.admin")}
                </T1Text>
                <SizedBox height={"10px"} />
                <C2Text fontColor={Theme.color.gray500}>디버그용 롤 변경 페이지</C2Text>
                <SizedBox height={"44px"} />
            </Column>
            <CustomInput
                padding={"15px 16px"}
                type={"select"}
                dropdownValues={countryValues}
                inputValue={selectedRole}
                setInputValue={handleChangeServerCountry}
            />
            <SizedBox height={"20px"} />
            <FullWidthButton onClick={handleSelect} text={"Select"} />
        </AuthContentWrapper>
    );
}

export default DebugRoleChangePage;
